import Vue from "vue";
import Amplify, { Auth } from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsconfig from "@/aws-exports";

const AmplifyModules = { ...Amplify, Auth };
Amplify.configure(awsconfig);

const amplify = Vue.use(AmplifyPlugin, AmplifyModules);

export default amplify;
